<template>
  <v-card
    id="dashboard-navigation-tabs"
    class="dashboard-navigation-card mb-6"
    elevation="0"
  >
    <v-tabs
      :value="activeTabIndex"
      slider-color="#ff1463"
      class="dashboard-tabs"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.key"
        :data-tab-key="tab.key"
        :class="{ 'tab-highlight': shouldHighlight && value === tab.key }"
        class="dashboard-tab"
        @click="handleTabClick(tab.key)"
      >
        {{ tab.label }}
        <v-chip v-if="tabCounts[tab.key] > 0" x-small class="tab-chip">
          {{ tabCounts[tab.key] }}
        </v-chip>
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  name: "DashboardNavigationTabs",

  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    tabCounts: {
      type: Object,
      required: true,
      default: () => ({})
    },
    value: {
      type: String,
      required: true,
      default: "all"
    },
    shouldHighlight: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    activeTabIndex() {
      const index = this.tabs.findIndex(tab => tab.key === this.value);
      return index >= 0 ? index : 0;
    }
  },

  methods: {
    handleTabClick(tabKey) {
      this.$emit("tab-click", tabKey);
    }
  }
};
</script>

<style scoped>
/* Card Container */
.dashboard-navigation-card {
  border: 1px solid #e5e7eb;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.dashboard-tabs {
  border-bottom: 1px solid #e5e7eb;
}

/* Tab Styles */
.dashboard-tab {
  text-transform: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  position: relative;
  overflow: hidden;
}

.tab-chip {
  margin-left: 8px;
  height: 20px;
  background-color: #f3f4f6;
  color: #6b7280;
}

/* Highlight Animation */
.tab-highlight {
  animation: highlight-pulse 1.5s ease-in-out;
  position: relative;
  overflow: hidden;
}

.tab-highlight::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 20, 99, 0.1);
  animation: highlight-fade 1.5s ease-in-out;
  pointer-events: none;
  z-index: 1;
}

/* Override Vuetify's default background for highlighted tab */
.tab-highlight.v-tab {
  background-color: transparent !important;
}

@keyframes highlight-pulse {
  0%,
  100% {
    background-color: transparent !important;
  }
  50% {
    background-color: rgba(255, 20, 99, 0.08) !important;
  }
}

@keyframes highlight-fade {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>